import { type TaxForm } from "@/api-v3";

import { TaxFormItem } from "./tax-form-item";

interface TaxFormListProps {
  data: TaxForm[];
}

export const TaxFormsList = ({ data }: TaxFormListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
      {data.map((item) => (
        <TaxFormItem key={item.submission_id} item={item} />
      ))}
    </div>
  );
};
